import React, { useState, useEffect } from "react";
import ChangePasswordModal from "./ChangePasswordModal";
import MessageAdminModal from "./MessageAdminModal";
import ApplicationMessagesModal from "./ApplicationMessagesModal";
import AdminThreadModal from "./AdminThreadModal";
import Select from 'react-select';




import "./StudentDashboard.css";

import {
  Card,
  ListGroup,
  Container,
  Row,
  Col,
  Button,
  Form,
  Alert,
  Table,
  Modal,
  Badge,
  ButtonGroup
} 


from "react-bootstrap";

// Utility to get initials
function getInitials(name) {
  

  if (!name) return "";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}



// Utility to pick a color for avatar (for demo, based on initials)
function pickAvatarColor(initials) {

  const palette = [
    "#6C63FF", "#43D9AD", "#FF7F50", "#EE4266", "#1B9AAA", "#FFD166", "#4ECDC4"
  ];
  if (!initials) return palette[0];
  let sum = 0;
  for (let i = 0; i < initials.length; i++) sum += initials.charCodeAt(i);
  return palette[sum % palette.length];
}



function StudentDashboard({ student, onProfileUpdate, onLogout, onSwitchRole }) {
   




  // --------------- All previous state/logic code as before ----------------
  const [paymentReceipt, setPaymentReceipt] = useState(null);

  const [editMode, setEditMode] = useState(false);
  const [profile, setProfile] = useState(null);


const [loadingProfile, setLoadingProfile] = useState(true);
const [error, setError] = useState('');
useEffect(() => {
  async function fetchProfile() {
    setLoadingProfile(true);
    setError('');
    try {
     
      const token = localStorage.getItem('authToken');
const res = await fetch(`/api/student/${student.email}`, {
  headers: {
    'Authorization': `Bearer ${token}`
  }
});
      if (!res.ok) throw new Error("Failed to load profile");
      const data = await res.json();
      setProfile(data);
    } catch (err) {
      setError("Could not load profile.");
    }
    setLoadingProfile(false);
  }
  if (student && student.email) fetchProfile();
}, [student]);


const [applications, setApplications] = useState([]);

function fetchApplications(email) {
  const token = localStorage.getItem('authToken');
  fetch(`/api/student/applications/${email}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .then(data => setApplications(data.applications || []))
    .catch(() => setApplications([]));
}




useEffect(() => {
  if (profile && profile.email) {
    const token = localStorage.getItem('authToken');
    fetch(`/api/student/applications/${profile.email}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => setApplications(data.applications || []))
      .catch(() => setApplications([]));
  }
}, [profile]);




useEffect(() => {
  if (student && student.email && profile) {
    const token = localStorage.getItem('authToken');
    fetch(`/api/student/admission-form/${student.email}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.admissionForm) {
          // Always merge profile name/email if missing in form
          setApplicationForm({
            ...data.admissionForm,
            name: data.admissionForm.name || profile.name || '',
            email: data.admissionForm.email || profile.email || '',
          });
          setApplicationFormSaved(true);
        } else {
          // If no form, create a new one using profile data
          setApplicationForm(prev => ({
            ...prev,
            name: profile.name || '',
            email: profile.email || '',
          }));
          setApplicationFormSaved(false);
        }
      })
      .catch(() => {
        setApplicationFormSaved(false);
      });
  }
}, [student, profile]);



useEffect(() => {
  if (profile && profile.email) {
    const token = localStorage.getItem('authToken');
    fetch(`/api/student/payment-receipt/${profile.email}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.paymentReceipt) {
          setPaymentReceipt(data.paymentReceipt);
        } else {
          setPaymentReceipt(null);
        }
      })
      .catch(() => {
        // Could not load payment receipt, leave as null
      });
  }
}, [profile]);


useEffect(() => {
  const token = localStorage.getItem('authToken');
  fetch('/api/institutes', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .then(data => setInstitutes(data.institutes || []))
    .catch(() => setInstitutes([]));
}, []);


useEffect(() => {
  if (profile && profile.email) {
    const token = localStorage.getItem('authToken');
    fetch(`/api/messages/admin-student/${profile.email}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.messages) {
          setAdminMessages(data.messages);
        } else {
          setAdminMessages([]);
        }
      })
      .catch(() => {
        setAdminMessages([]); // fallback: show none
      });

   
  }
}, [profile]);


const [academies, setAcademies] = useState([]);


useEffect(() => {
  fetch('/api/academies')
    .then(res => res.json())
    .then(data => setAcademies(data.academies || []))
    .catch(() => setAcademies([]));
}, []);

const academyOptions = academies.map(acad => ({
  value: acad.email,
  label: `${acad.name} (${acad.city})`
}));






//session selection
const [selectedSession, setSelectedSession] = useState({});




  const [message, setMessage] = useState('');
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('');
  const [applyError, setApplyError] = useState('');
  const [forceUpdate, setForceUpdate] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profileStudent, setProfileStudent] = useState(null);
  const [showAppFormModal, setShowAppFormModal] = useState(false);
  const [docUploadError, setDocUploadError] = useState('');
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [institutes, setInstitutes] = useState([]);
  const [adminMessages, setAdminMessages] = useState([]);
 
// --- Application Messaging (thread per application) ---
const [showAppMsgModal, setShowAppMsgModal] = useState(false);
const [activeAppMsg, setActiveAppMsg] = useState(null); // { ...app, instituteEmail }
const [appMsgThread, setAppMsgThread] = useState([]);
const [appMsgLoading, setAppMsgLoading] = useState(false);
const [appMsgText, setAppMsgText] = useState('');
const [appMsgError, setAppMsgError] = useState('');


// Accept Offer States

const [showAcceptOfferModal, setShowAcceptOfferModal] = useState(false);
const [acceptingApp, setAcceptingApp] = useState(null);
const [acceptOfferUploading, setAcceptOfferUploading] = useState(false);
const [acceptOfferError, setAcceptOfferError] = useState('');
const acceptedAppId = applications.find(app => app.offerAccepted)?. _id;
const [acceptOfferFile, setAcceptOfferFile] = useState(null); // Selected but not uploaded

const [showAcceptConfirm, setShowAcceptConfirm] = useState(false);
const [pendingAcceptOfferSubmit, setPendingAcceptOfferSubmit] = useState(false);





const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const API_BASE = isDev ? "http://localhost:5000" : "";

function getDocDownloadUrl(doc) {
  return doc?.url ? `${API_BASE}${doc.url}` : '#';
}



  const [applicationForm, setApplicationForm] = useState({
  photo: null,
  program: '',
  altProgram: '',
  rollNo: '',
  name: '',
  fatherName: '',
  cnic: '',
  dob: '',
  gender: '',
  presentAddress: '',
  permanentAddress: '',
  domicile: '',
  locality: '',
  nationality: '',
  maritalStatus: '',
  identificationMark: '',
  religion: '',
  bloodGroup: '',
  email: '',
  guardianCell: '',
  cell: '',
  academicRecords: [
    {
      qualification: '',
      passingYear: '',
      rollNo: '',
      totalMarks: '',
      obtainedMarks: '',
      percentage: '',
      board: '',
      registrationNo: '',
      examination: ''
    }
  ],
  documentChecklist: {
    matriculation: false,
    intermediate: false,
    graduation: false,
    photographs: false,
    cnicStudent: false,
    cnicStudentBack: false,
    cnicFather: false,
    cnicFatherBack: false,
    domicile: false
  },
  declarationAgreed: false
});

const [applicationFormSaved, setApplicationFormSaved] = useState(false);


function isApplicationFormSaved() {
  // Define the required fields for "completed" form
  return (
    applicationForm &&
    applicationForm.name &&
    applicationForm.email &&
    
    applicationForm.declarationAgreed
  );
}



// Always sync applicationForm.photo with actual documents in profile
useEffect(() => {
  if (!profile) return;
  // Find current photo doc (if any)
  const photoDoc = (profile.documents || []).find(
    d => (d.typeTag && d.typeTag === 'photo') || (d.name && d.name.toLowerCase() === 'photo')
  );
  // If applicationForm.photo exists but no photoDoc, clear it
  if (!photoDoc && applicationForm.photo) {
    setApplicationForm(form => ({ ...form, photo: null }));
  }
  // If a photoDoc exists and form.photo is not set or not up-to-date, update it
  if (photoDoc && photoDoc.url !== applicationForm.photo) {
    setApplicationForm(form => ({ ...form, photo: photoDoc.url }));
  }
}, [profile, applicationForm.photo]);



  

  // Change Password State
  const [showChangePwdModal, setShowChangePwdModal] = useState(false);
  const [oldPwd, setOldPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [pwdError, setPwdError] = useState('');
  const [pwdSuccess, setPwdSuccess] = useState('');

  // Message Admin State
  const [showAdminMsgModal, setShowAdminMsgModal] = useState(false);
  const [adminMsgText, setAdminMsgText] = useState('');
  const [adminMsgSendError, setAdminMsgSendError] = useState('');
  const [adminMsgSendSuccess, setAdminMsgSendSuccess] = useState('');
  const [showAdminThread, setShowAdminThread] = useState(false);

const [selectedDeptCourse, setSelectedDeptCourse] = useState({});

// Defensive: make sure currentMe is always an object and applications is always an array!



  // Admin Messages
  // This will always show the latest messages from backend!
const myAdminMsgs = Array.isArray(adminMessages) ? adminMessages : [];



  const hasNewAdmin = myAdminMsgs.some(m => m.from === "admin" && !m.read);



  // Profile Change handlers
 function handleChange(e) {
  if (!profile) return;

  setProfile(prev => ({ ...prev, [e.target.name]: e.target.value }));
}


  // New: Upload documents as files (to /uploads/studentDocs) -- URLs saved in DB
function handleDocumentUpload(e) {
  if (!profile) return;
  const files = Array.from(e.target.files);
  for (let file of files) {
    if (file.size > 5 * 1024 * 1024) { // 5MB max per file (backend also limits)
      alert('File is too large! Please upload files smaller than 5 MB.');
      e.target.value = "";
      return;
    }
  }

  files.forEach(file => {
    const formData = new FormData();
    formData.append('email', profile.email);
    formData.append('document', file);
    formData.append('documentType', file.name);

    const token = localStorage.getItem('authToken');
    fetch('/api/student/upload-document', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && data.document) {
          setProfile(prev => ({
            ...prev,
            documents: [...(prev.documents || []), data.document]
          }));
          setMessage('Document(s) uploaded successfully!');
        } else {
          setMessage('Could not upload document. Please try again.');
        }
        e.target.value = "";
      })
      .catch(() => {
        setMessage('Could not connect to server. Please try again.');
        e.target.value = "";
      });
  });
}



  async function handleSave(e) {
  e.preventDefault();
  setError('');
  try {
    const token = localStorage.getItem('authToken');
    const res = await fetch('/api/student/update', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ ...profile, email: profile.email }),
    });
    const data = await res.json();
    if (!res.ok) {
      setError(data.message || 'Update failed.');
      return;
    }
    setProfile(data.student);
    setMessage('Profile updated successfully!');
    setEditMode(false);
    if (onProfileUpdate) onProfileUpdate(data.student);
  } catch (err) {
    setError('Network error. Please try again.');
  }
}



function handleRemoveDocument(index) {
  if (!profile) return;
  const docToRemove = documents[index];
  const token = localStorage.getItem('authToken');

  fetch('/api/student/remove-document', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      email: profile.email,
      docUrl: docToRemove.url,
      typeTag: docToRemove.typeTag // For checklist docs, else undefined
    })
  })
    .then(res => res.json())
    .then(data => {
      if (data.success && data.documents) {
        setProfile(prevForm => ({ ...prevForm, documents: data.documents }));
        setMessage('Document removed successfully!');

        // ---- NEW: Clear photo or receipt in admission form if removed ----
        setApplicationForm(prev => {
          let updated = { ...prev };
          // If the removed doc was photo, clear photo field
          if (
            docToRemove.typeTag === 'photo' ||
            (docToRemove.name && docToRemove.name.toLowerCase() === 'photo')
          ) {
            updated.photo = null;
          }
          // If removed doc is any kind of receipt, clear paymentReceipt field
          if (
            (docToRemove.typeTag && docToRemove.typeTag.toLowerCase().includes('receipt')) ||
            (docToRemove.name && docToRemove.name.toLowerCase().includes('receipt'))
          ) {
            updated.paymentReceipt = null;
          }
          return updated;
        });
        // ---------------------------------------------------------------
      } else {
        setMessage('Could not update documents. Please try again.');
      }
    })
    .catch(() => {
      setMessage('Could not connect to server. Please try again.');
    });
}





if (loadingProfile) return <div>Loading profile...</div>;
if (error) return <Alert variant="danger">{error}</Alert>;

if (!student || !student.email) {
  return <div style={{ color: 'red', fontWeight: 600 }}>Student not found. Please login again.</div>;
}
if (!profile || typeof profile !== 'object') {
  return <div>Loading profile...</div>;
}



const documents = Array.isArray(profile?.documents) ? profile.documents : [];
const canApply = applications.length < 10;




  function handleDeptChange(instEmail, dept) {
    setSelectedDeptCourse(prev => ({
      ...prev,
      [instEmail]: {
        department: dept,
        course: ''
      }
    }));
  }
  function handleCourseChange(instEmail, course) {
    setSelectedDeptCourse(prev => ({
      ...prev,
      [instEmail]: {
        ...prev[instEmail],
        course: course
      }
    }));
  }

// Session Option Generator Function
function generateSessionOptions() {
  const now = new Date();
  const year = now.getFullYear();
  const nextYear = year + 1;
  return [
    { value: `Fall ${year}`, label: `Fall ${year} ` },
    { value: `Spring ${year}`, label: `Spring ${year} ` },
    { value: `Fall ${nextYear}`, label: `Fall ${nextYear} ` },
    { value: `Spring ${nextYear}`, label: `Spring ${nextYear} ` },
  ];
}




 function handleInlineApply(inst) {
  const selection = selectedDeptCourse[inst.email];
  if (!selection || !selection.department || !selection.course) {
    setApplyError('Please select both department and course.');
    setMessage('');
    return;
  }
  const alreadyApplied = applications.some(app =>
    app.instituteEmail === inst.email &&
    app.department === selection.department &&
    app.course === selection.course
  );
  if (alreadyApplied) {
    setApplyError('You have already applied to this course in this institute.');
    setMessage('');
    return;
  }
  // Limit to 3 applications per institute
  const applicationsToThisInstitute = applications.filter(app => app.instituteEmail === inst.email);
  if (applicationsToThisInstitute.length >= 3) {
    setApplyError('You can only apply to up to 3 courses/programs in this institute.');
    setMessage('');
    return;
  }

if (!selectedSession[inst.email]) {
  setApplyError('Please select a session.');
  setMessage('');
  return;
}



  if (!canApply) {
    setApplyError('You can only apply to up to 10 institutes.');
    setMessage('');
    return;
  }
  const newApp = {
    instituteEmail: inst.email,
    instituteName: inst.name,
    department: selection.department,
    course: selection.course,
    session: selectedSession[inst.email],
    date: new Date().toLocaleDateString(),
    status: "pending",
    messages: []
  };
  // --- NEW: Only send one new application to backend ---
  const token = localStorage.getItem('authToken');
  fetch('/api/student/applications', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ email: profile.email, application: newApp }) // <--- changed!
  })
    .then(res => res.json())
    .then(data => {
  if (data.application) {
    setMessage("Application submitted successfully!");
    fetchApplications(profile.email); // <--- This fetches latest applications!
  } else {
    setMessage("Could not submit application. Please try again.");
  }
})

    .catch(() => setMessage("Could not connect to server. Please try again."));

  setApplyError('');
  setForceUpdate(f => !f);
}




 

function handleWithdraw(idx) {
  // Get the application _id from the applications array
  const appId = applications[idx]._id;
  const token = localStorage.getItem('authToken');
  fetch(`/api/student/applications/${appId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .then(data => {
      if (data.message === "Application withdrawn.") {
        setMessage("Application withdrawn.");
        // Refresh the applications list from backend
        fetchApplications(profile.email);
      } else {
        setMessage("Could not withdraw application. Please try again.");
      }
    })
    .catch(() => setMessage("Could not connect to server. Please try again."));
}




// "Open Messages Modal" function

function handleOpenAppMsgModal(app) {
  setActiveAppMsg(app);
  setShowAppMsgModal(true);
  setAppMsgLoading(true);
  setAppMsgText('');
  setAppMsgError('');

  const token = localStorage.getItem('authToken');
    fetch(`/api/applications/messages?studentEmail=${encodeURIComponent(profile.email)}&instituteEmail=${encodeURIComponent(app.instituteEmail)}&course=${encodeURIComponent(app.course)}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
    .then(res => res.json())
    .then(data => {
      setAppMsgThread(data.messages || []);
      setAppMsgLoading(false);

      // Mark all institute messages as read
      fetch('/api/applications/messages/mark-read', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          studentEmail: profile.email,
          instituteEmail: app.instituteEmail,
          course: app.course
        })
      }).then(() => {
        // Reload profile so application list is refreshed (badges update)
        fetch(`/api/student/${profile.email}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
          .then(res => res.json())
          .then(freshProfile => setProfile(freshProfile));
      });
    })

    .catch(() => {
      setAppMsgError('Could not load messages');
      setAppMsgLoading(false);
    });
}

// "Send Message" function

function handleSendAppMsg() {
  if (!activeAppMsg || !appMsgText.trim()) return;
  setAppMsgLoading(true);
  setAppMsgError('');
  const token = localStorage.getItem('authToken');
  fetch('/api/applications/message', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      studentEmail: profile.email,
      instituteEmail: activeAppMsg.instituteEmail,
      course: activeAppMsg.course,
      text: appMsgText.trim()
    })
  })
    .then(res => res.json())
    .then(data => {
      setAppMsgThread(data.messages || []);
      setAppMsgText('');
      setAppMsgLoading(false);
    })
    .catch(() => {
      setAppMsgError('Could not send message');
      setAppMsgLoading(false);
    });
}






  // --- Password Change Logic ---
  function handleOpenChangePwd() {
    setOldPwd('');
    setNewPwd('');
    setConfirmPwd('');
    setPwdError('');
    setPwdSuccess('');
    setShowChangePwdModal(true);
  }
 async function handleChangePwdSubmit(e) {
  e.preventDefault();
  setPwdError('');
  setPwdSuccess('');
  if (!oldPwd || !newPwd || !confirmPwd) {
    setPwdError('Please fill all fields.');
    return;
  }
  if (newPwd.length < 5) {
    setPwdError('New password must be at least 5 characters.');
    return;
  }
  if (newPwd !== confirmPwd) {
    setPwdError('New password and confirm password do not match.');
    return;
  }
  try {
    const token = localStorage.getItem('authToken');
    const res = await fetch('/api/student/change-password', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        email: profile.email,
        oldPassword: oldPwd,
        newPassword: newPwd
      })
    });
    const data = await res.json();
    if (!res.ok) {
      setPwdError(data.message || 'Password change failed.');
      return;
    }
    setPwdSuccess('Password updated successfully!');
    setPwdError('');
    setTimeout(() => setShowChangePwdModal(false), 1200);
  } catch (err) {
    setPwdError('Network error. Please try again.');
  }
}



  // --- ADMIN MESSAGE HANDLERS ---
 function handleSendAdminMsg() {
  if (!profile) return;
  if (!adminMsgText.trim()) {
    setAdminMsgSendError('Cannot send empty message.');
    setAdminMsgSendSuccess('');
    return;
  }

  const token = localStorage.getItem('authToken');
  fetch('/api/messages/student-admin/send', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ text: adminMsgText.trim() })
  })
    .then(res => res.json())
    .then(data => {
      if (data.msg) {
        setAdminMsgText('');
        setAdminMsgSendError('');
        setAdminMsgSendSuccess('Message sent to admin!');
        setTimeout(() => {
          setShowAdminMsgModal(false);
          setAdminMsgSendSuccess('');
        }, 1200);
        // Fetch latest admin messages from backend to refresh UI
        fetch(`/api/messages/admin-student/${profile.email}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
          .then(res => res.json())
          .then(data => {
            if (data.messages) {
              setAdminMessages(data.messages);
            }
          });
      } else {
        setAdminMsgSendError('Could not send message. Try again.');
      }
    })
    .catch(() => {
      setAdminMsgSendError('Could not connect to server. Try again.');
    });
}


function handleOpenAdminThread() {
  if (!profile) return;

  const token = localStorage.getItem('authToken');
  // Call backend to mark all admin messages as read (NEW ENDPOINT AND BODY)
  fetch('/api/messages/mark-read', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ userType: "student", userEmail: profile.email })
  })
    .then(res => res.json())
    .then(() => {
      // After marking as read, fetch updated messages (NEW ENDPOINT)
      fetch(`/api/messages/admin-student/${profile.email}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
        .then(res => res.json())
        .then(data => {
          

          if (data.messages) {
            setAdminMessages(data.messages);
          } else {
            setAdminMessages([]);
          }
          setShowAdminThread(true);
        });
    })
    .catch(() => {
      // Still open the thread, but might show stale data
      setShowAdminThread(true);
    });
}



  

  // AVATAR
  const initials = getInitials(profile?.name || profile?.email);

  const avatarColor = pickAvatarColor(initials);
  // Helper: Find uploaded document by type (e.g., 'matriculation')
function getChecklistDoc(type) {
  if (!profile) return;

  return documents.find(doc => doc.typeTag === type);
}

// Helper: Upload a document for a checklist item
// New: Upload checklist doc via backend endpoint, store as URL
function handleChecklistDocUpload(e, docType, docLabel) {
  if (!profile) return; 
  const file = e.target.files[0];
  if (!file) return;
  if (file.size > 5 * 1024 * 1024) { // 5MB max per file
    alert('File is too large! Please upload files smaller than 5 MB.');
    e.target.value = "";
    return;
  }

  const formData = new FormData();
  formData.append('email', profile.email);
  formData.append('document', file);
  formData.append('documentType', docLabel + '_' + file.name);
  formData.append('typeTag', docType);

  const token = localStorage.getItem('authToken');
  fetch('/api/student/upload-document', {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData
  })
    .then(res => res.json())
    .then(data => {
      if (data.success && data.document) {
        // Remove old document of same typeTag, add new one
        let updatedDocs = (profile.documents || []).filter(doc => doc.typeTag !== docType);
        // Attach typeTag to new doc
        updatedDocs.push({ ...data.document, typeTag: docType });

        setProfile(prevForm => ({
          ...prevForm,
          documents: updatedDocs
        }));
        // Keep checkbox checked after upload, and save form to backend
        setApplicationForm(form => {
          const updatedForm = {
            ...form,
            documentChecklist: {
              ...form.documentChecklist,
              [docType]: true
            }
          };

          // Save checklist to backend (no change here)
          fetch('/api/student/admission-form', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              email: profile.email,
              admissionForm: updatedForm
            })
          });
          return updatedForm;
        });
      }
      e.target.value = "";
    });
}


// Helper: Remove a checklist document
function removeChecklistDoc(docType) {
  if (!profile) return;
  // Find the document to remove by typeTag
  const docToRemove = documents.find(doc => doc.typeTag === docType);
  if (!docToRemove) return;

  const token = localStorage.getItem('authToken');
  fetch('/api/student/remove-document', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      email: profile.email,
      docUrl: docToRemove.url,
      typeTag: docType
    })
  })
    .then(res => res.json())
    .then(data => {
      if (data.success && data.documents) {
        setProfile(prevForm => ({ ...prevForm, documents: data.documents }));
        // (Optional) If you want to also update checklist UI:
        setApplicationForm(form => ({
          ...form,
          documentChecklist: {
            ...form.documentChecklist,
            [docType]: false
          }
        }));
      }
    })
    .catch(() => {
      // Optionally show error to user
    });
}



  // UI starts here (SINGLE COLUMN LAYOUT, NO TOP BAR)
  
  return (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%)"
    }}
  >
    <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginBottom: 24 }}>
      <Button variant="outline-danger" onClick={onLogout}>Logout</Button>
    </div>

    <Container className="mt-3" style={{ maxWidth: 1400 }}>
      <Row className="justify-content-center">
        <Col xs={12} md={12} lg={12} xl={12}>
          {/* PROFILE CARD */}
          <Card
            className="shadow-lg mb-4"
            style={{
              borderRadius: 24,
              border: "none",
              background: "rgba(255,255,255,0.98)",
            }}
          >
            <Card.Body>
              {/* Avatar and Name Row */}
              <div
  className="dashboard-avatar-row"
  style={{
    display: "flex",
    alignItems: "center",
    gap: 18,
    marginBottom: 18,
    flexWrap: "wrap"
  }}
>
  {/* Avatar */}
  <div
    style={{
      width: 60,
      height: 60,
      borderRadius: "50%",
      background: avatarColor,
      color: "#fff",
      fontWeight: 700,
      fontSize: 30,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 2px 8px #e0e6ed",
      userSelect: "none",
      letterSpacing: "2px",
    }}
  >
    {initials}
  </div>

  {/* Name + Badge */}
  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
    <span style={{ fontWeight: 600, fontSize: 26 }}>
      {profile?.name}
    </span>
    {profile?.paid && (
      <span
        style={{
          background: "#22c55e",
          color: "#fff",
          borderRadius: "5px",
          fontSize: "0.95em",
          fontWeight: "bold",
          padding: "3px 12px",
          display: "inline-block"
        }}
        title="Registration fee paid"
      >
        Active
      </span>
    )}
  </div>

  {/* Welcome text */}
  <div style={{ fontSize: 15, color: "#667", width: "100%" }}>
    Welcome to your Dashboard
  </div>
</div>

              
              {/* Alert for unpaid users */}
              {!profile?.paid && (
                <Alert
                  variant="warning"
                  className="mb-2 text-center"
                  style={{
                    fontWeight: 500,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 14
                  }}
                >
                  <span>Please pay registration fee to submit your applications.</span>
                  <Button
                    variant="outline-info"
                    size="sm"
                    style={{ fontWeight: 600, borderRadius: 8, padding: '2px 12px' }}
                    onClick={() => setShowPaymentModal(true)}
                  >
                    How to Pay
                  </Button>
                </Alert>
              )}
              

                {/* Modern Button Group */}
                <ButtonGroup
  className="mb-3 d-flex flex-wrap"
  style={{ width: "100%", gap: 10, flexDirection: "row" }}
>
                  <Button
                    variant={editMode ? "outline-primary" : "primary"}
                    size="sm"
                    style={{
                      minWidth: 110,
                      fontWeight: 500,
                      borderRadius: 12,
                      boxShadow: editMode ? "none" : "0 2px 6px #c7d2fe77",
                    }}
                    onClick={() => setEditMode((prev) => !prev)}
                  >
                    {editMode ? "Cancel" : "Edit Profile"}
                  </Button>
                  <Button
                    variant="outline-success"
                    size="sm"
                    style={{
                    minWidth: 150,
                    fontWeight: 500,
                    borderRadius: 12,
                    }}
                    onClick={() => setShowAppFormModal(true)}
                  >
                    Admissions Form
                  </Button>
                  <Button
                    variant="outline-warning"
                    size="sm"
                    style={{
                      minWidth: 120,
                      fontWeight: 500,
                      borderRadius: 12,
                    }}
                    onClick={handleOpenChangePwd}
                  >
                    Change Password
                  </Button>
                  <Button
                    variant="outline-info"
                    size="sm"
                    style={{
                      minWidth: 145,
                      fontWeight: 500,
                      borderRadius: 12,
                    }}
                    onClick={() => setShowAdminMsgModal(true)}
                  >
                    Message Admin
                  </Button>
                  <Button
                    variant="info"
                    size="sm"
                    style={{
                      minWidth: 160,
                      fontWeight: 500,
                      borderRadius: 12,
                    }}
                    onClick={handleOpenAdminThread}
                  >
                    View Admin Messages
                    {hasNewAdmin && <Badge bg="danger" className="ms-2">New</Badge>}
                  </Button>
                </ButtonGroup>
                <hr style={{ marginTop: 4, marginBottom: 18 }} />

                <Card.Text style={{ fontSize: 17, color: "#435" }}>
                  Profile Information:
                </Card.Text>
                {editMode ? (
                  <Form onSubmit={handleSave}>
                    <Form.Group className="mb-3">
                      <Form.Label>Name*</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={profile?.name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Email*</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={profile?.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Phone*</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        value={profile?.phone}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={profile?.address}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control
                        type="date"
                        name="dob"
                        value={profile?.dob}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Gender</Form.Label>
                      <Form.Select
                        name="gender"
                        value={profile?.gender}
                        onChange={handleChange}
                      >
                        <option value="">Select...</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                        <option value="Prefer not to say">Prefer not to say</option>
                      </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Nationality</Form.Label>
                      <Form.Control
                        type="text"
                        name="nationality"
                        value={profile?.nationality}
                        onChange={handleChange}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
  <Form.Label>Upload Documents</Form.Label>
  
  <div style={{
    background: '#e3f2fd',
    color: '#e63e3eff',
    fontWeight: 'bold',
    padding: '8px 12px',
    borderRadius: 8,
    marginBottom: 8,
    border: '1px solid #90caf9'
  }}>
    Please upload your Qualification Documents in Admission Form above.
  </div>
  
  <Form.Control
    type="file"
    multiple
    onChange={handleDocumentUpload}
    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif"
  />
  <Form.Text>
    (You can upload PDF, Word, or image files. Uploaded files are saved with your profile.)
  </Form.Text>
</Form.Group>

<Form.Group className="mb-3">
  <Form.Label>Referred By (Academy/Consultant)</Form.Label>
  <Select
    options={academyOptions}
    value={academyOptions.find(opt => opt.value === profile.referredBy) || null}
    onChange={option => setProfile(prev => ({ ...prev, referredBy: option ? option.value : "" }))}
    isClearable
    placeholder="Select or search..."
    noOptionsMessage={() => "No matching academy"}
    styles={{
      menu: provided => ({ ...provided, maxHeight: 220 }),
      container: provided => ({ ...provided, maxWidth: 350 })
    }}
  />
</Form.Group>



                    <Button variant="success" type="submit" className="me-2">
                      Save
                    </Button>
                    <Button variant="secondary" onClick={() => setEditMode(false)}>
                      Cancel
                    </Button>
                  </Form>
                ) : (
                  <ListGroup variant="flush">
                    <ListGroup.Item><b>Name:</b> {profile?.name}</ListGroup.Item>
                    <ListGroup.Item><b>Email:</b> {profile?.email}</ListGroup.Item>
                    <ListGroup.Item><b>Phone:</b> {profile?.phone}</ListGroup.Item>
                    {profile?.address && <ListGroup.Item><b>Address:</b> {profile?.address}</ListGroup.Item>}
                    {profile?.dob && <ListGroup.Item><b>Date of Birth:</b> {profile?.dob}</ListGroup.Item>}
                    {profile?.gender && <ListGroup.Item><b>Gender:</b> {profile?.gender}</ListGroup.Item>}
                    {profile?.nationality && <ListGroup.Item><b>Nationality:</b> {profile?.nationality}</ListGroup.Item>}
                    {profile?.referredBy && (
  <ListGroup.Item>
    <b>Referred By:</b>{" "}
    {academies.find(a => a.email === profile.referredBy)?.name || profile.referredBy}
  </ListGroup.Item>
)}

                  </ListGroup>
                )}

                {/* Documents Section */}
                <div className="mt-4">
                  <h5>Uploaded Documents:</h5>
                  {documents.length > 0 ? (
  <ListGroup>
    {documents.map((doc, i) => (
      <ListGroup.Item key={i}>
       <a
  href={getDocDownloadUrl(doc)}
  download={doc.name}
  target="_blank"
  rel="noopener noreferrer"
>
  {doc.name}
</a>


       {![ "receipt", "paymentreceipt", "challan"].includes(
    (doc.typeTag || doc.name || "").toLowerCase()
  ) && (
    <Button
      variant="outline-danger"
      size="sm"
      style={{ float: 'right' }}
      onClick={() => handleRemoveDocument(i)}
    >
      Remove
    </Button>
)}

      </ListGroup.Item>
    ))}
  </ListGroup>
) : (
  <div className="text-muted">No documents uploaded yet.</div>
)}

                </div>
                {message && <Alert variant="success" className="mt-3 text-center">{message}</Alert>}
                {applyError && <Alert variant="danger" className="mt-3 text-center">{applyError}</Alert>}
              </Card.Body>
            </Card>

            
            {/* --- Applications Table (with messages) --- */}
            <Card className="shadow mb-4" style={{ borderRadius: 24, background: "rgba(255,255,255,0.98)" }}>
              <Card.Header as="h5">
                Your Applications
                <span className="float-end text-muted" style={{ fontSize: 14 }}>
                  ({applications.length}/10 applications)
                </span>
              </Card.Header>
              <Card.Body>
                {applications.length === 0 ? (
                  <div className="text-muted">You haven't applied to any institute yet.</div>
                ) : (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Institute</th>
                        <th>Department</th>
                        <th>Programs</th>
                        <th>Date/Session</th>
                        <th>Status</th>
                        <th>Withdraw</th>
                        <th>Messages</th>
                      </tr>
                    </thead>
                    <tbody>
                      {applications.map((app, i) => (
                        <tr key={i}>
                          <td>{app.instituteName}</td>
                          <td>{app.department}</td>
                          <td>{app.course}</td>
                          <td> {app.session ? app.session + ' - ' : ''}
                               {app.date} 
                               </td>
                          <td style={{ textTransform: "capitalize" }}>
                            <span
                              className={
                                app.status === "approved"
                                  ? "text-success"
                                  : app.status === "rejected"
                                    ? "text-danger"
                                    : "text-secondary"
                              }
                            >
                              {app.status ? app.status : "pending"}
                            </span>
                          </td>
                         <td>
  {(app.status === "approved" && !app.offerAccepted && !acceptedAppId) ? (
    <Button
      size="sm"
      variant="success"
      onClick={() => {
        setAcceptingApp(app);
        setShowAcceptOfferModal(true);
        setAcceptOfferError('');
      }}
    >
      Accept Offer
    </Button>
  ) : (app.status === "approved" && app.offerAccepted) ? (
    <span style={{ color: "#22c55e", fontWeight: 600 }}>Offer Accepted</span>
  ) : ((!app.status || app.status === "pending") ? (
    <Button
      size="sm"
      variant="danger"
      onClick={() => handleWithdraw(i)}
    >
      Withdraw
    </Button>
  ) : (
    <span className="text-muted">-</span>
  ))}
</td>

                         <td>
  <Button
    size="sm"
    variant="info"
    style={{ borderRadius: 8 }}
    onClick={() => handleOpenAppMsgModal(app)}
    disabled={app.status !== "approved"}
    title={app.status !== "approved" ? "Only available for approved applications" : ""}
  >
    Messages
    {/* Show badge if there are unread institute messages */}
    {Array.isArray(app.messages) && app.messages.some(m => m.from === "institute" && !m.read) && (
      <Badge bg="danger" className="ms-1">New</Badge>
    )}
  </Button>
</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            </Card>
<Modal show={showAcceptOfferModal} onHide={() => setShowAcceptOfferModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title style={{ color: "#2d388a", fontSize: 22, fontWeight: 700 }}>
      Upload Admission Proof
    </Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p style={{ fontSize: 17, color: "#333" }}>
      Please upload your <span style={{ color: "#0072c6", fontWeight: 600 }}>fee challan/receipt</span> as proof of joining <br />
      <b style={{ color: "#208b5e", fontSize: 18 }}>
        {acceptingApp?.instituteName} — {acceptingApp?.course}
      </b>
    </p>
    {acceptOfferError && <Alert variant="danger" style={{ fontSize: 16 }}>{acceptOfferError}</Alert>}
    <Form.Group className="mb-3">
      <Form.Label style={{ color: "#222", fontWeight: 500, fontSize: 16 }}>
        Fee Challan or Admission Receipt <span style={{ color: "#c62828" }}>(PDF, JPG, PNG):</span>
      </Form.Label>
      <Form.Control
        type="file"
        accept=".pdf,.jpg,.jpeg,.png"
        disabled={acceptOfferUploading}
        onChange={e => {
          setAcceptOfferError('');
          const file = e.target.files[0];
          if (!file) return setAcceptOfferFile(null);
          if (file.size > 5 * 1024 * 1024) {
            setAcceptOfferError("File too large! Max 5 MB.");
            setAcceptOfferFile(null);
            return;
          }
          setAcceptOfferFile(file); // just save it for now
        }}
        style={{ fontSize: 15, color: "#2076d1", borderColor: "#bbb" }}
      />
      {acceptOfferFile && (
        <div style={{ color: "#1a4e25", fontSize: 15, marginTop: 8 }}>
          Selected: <b>{acceptOfferFile.name}</b>
        </div>
      )}
    </Form.Group>
    <div className="mt-3 d-flex justify-content-end">
      <Button
        variant="secondary"
        style={{ fontSize: 15, marginRight: 8 }}
        onClick={() => setShowAcceptOfferModal(false)}
      >
        Cancel
      </Button>
      <Button
        variant="success"
        style={{ fontSize: 16, fontWeight: 600, minWidth: 120 }}
        disabled={!acceptOfferFile || acceptOfferUploading}
      onClick={() => {
  if (!acceptOfferFile) {
    setAcceptOfferError("Please select a document first.");
    return;
  }
  setShowAcceptConfirm(true); // show your custom confirmation modal
}}

      >
        Submit
      </Button>
    </div>
  </Modal.Body>
</Modal>







            {/* --- Apply to Institutes (INLINE DROPDOWNS & NO MODAL) --- */}
            <Card className="shadow mb-4" style={{ borderRadius: 24, background: "rgba(255,255,255,0.98)" }}>
 <Card.Header as="h5" style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center" }}>
  <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    <span>Apply to Institutes</span>
    <span className="text-muted" style={{ fontSize: 14 }}>
      ({canApply ? `${10 - applications.length} applications left` : "Limit reached"})
    </span>
  </div>
  <div
    style={{
      width: "100%",
      textAlign: "center",
      fontSize: "0.75em",
      color: "#d32f2f",
      fontWeight: 500,
      marginTop: 2,
    }}
  >
    Please fill your Admissions form Completely above before you apply.
  </div>
</Card.Header>


  <Card.Body>
    {Array.isArray(institutes) && institutes.length === 0 ? (
      <div className="text-muted">No institutes available yet.</div>
    ) : (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Institute Name</th>
            
            <th>Department</th>
            <th>Programs</th>
            <th>Session</th>
            <th>Apply</th>
            <th>Website</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(institutes) ? institutes.map((inst, i) => {
  const selected = selectedDeptCourse[inst.email] || {};
  const deptOptions = Array.isArray(inst.departments) ? inst.departments : [];
  const selectedDept = deptOptions.find(d => d.name === selected.department);
  const courseOptions = Array.isArray(selectedDept?.courses) ? selectedDept.courses : [];
  return (
    <tr key={i}>
      <td>{inst.name}</td>
      <td className="dept-col">
        <Form.Select
          value={selected.department || ''}
          onChange={e => handleDeptChange(inst.email, e.target.value)}
        >
          <option value="">Choose...</option>
          {deptOptions.map((dept, idx) =>
            <option key={idx} value={dept.name}>{dept.name}</option>
          )}
        </Form.Select>
      </td>
      <td className="course-col">
        <Form.Select
          value={selected.course || ''}
          onChange={e => handleCourseChange(inst.email, e.target.value)}
          disabled={!selected.department}
        >
          <option value="">Choose...</option>
          {courseOptions.map((c, idx) =>
            <option key={idx} value={c}>{c}</option>
          )}
        </Form.Select>
      </td>
        
        <td>
  <Form.Select
    value={selectedSession[inst.email] || ''}
    onChange={e => setSelectedSession(prev => ({
      ...prev,
      [inst.email]: e.target.value
    }))}
  >
    <option value="">Select Session</option>
    {generateSessionOptions().map(opt => (
      <option key={opt.value} value={opt.value}>{opt.label}</option>
    ))}
  </Form.Select>
</td>



      <td>
        <Button
          size="sm"
          variant="primary"
          disabled={!canApply || !profile.paid || !isApplicationFormSaved()}
          onClick={() => {
            if (!isApplicationFormSaved()) {
              alert("Please fill and save your application form before applying.");
              return;
            }
            handleInlineApply(inst);
          }}
        >
          Apply
        </Button>
      </td>
      <td>
        {inst.website && (
          <Button
            as="a"
            href={inst.website.startsWith('http') ? inst.website : `https://${inst.website}`}
            target="_blank"
            rel="noopener noreferrer"
            variant="outline-info"
            size="sm"
            style={{ fontWeight: 500, minWidth: 100 }}
          >
            Visit Website
          </Button>
        )}
      </td>
    </tr>
  );
}) : null}

        </tbody>
      </Table>
    )}
  </Card.Body>
</Card>

          </Col>
        </Row>
      </Container>

      {/* Change Password Modal */}
    <ChangePasswordModal
  show={showChangePwdModal}
  onHide={() => setShowChangePwdModal(false)}
  oldPwd={oldPwd}
  setOldPwd={setOldPwd}
  newPwd={newPwd}
  setNewPwd={setNewPwd}
  confirmPwd={confirmPwd}
  setConfirmPwd={setConfirmPwd}
  pwdError={pwdError}
  pwdSuccess={pwdSuccess}
  handleChangePwdSubmit={handleChangePwdSubmit}
/>

{/* --- Submit Button Warning For Offer accept Dcoumnet Modal --- */}

<Modal
  show={showAcceptConfirm}
  onHide={() => setShowAcceptConfirm(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title style={{ fontWeight: 700, color: "#233876" }}>
      Universities Admission Service
    </Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ fontSize: 16, color: "#95230b" }}>
    Are you sure? <br />
    <span style={{ color: "#b71c1c" }}>You cannot undo this action.</span>
  </Modal.Body>
  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowAcceptConfirm(false)}
    >
      Cancel
    </Button>
    <Button
      variant="danger"
      onClick={async () => {
        setShowAcceptConfirm(false);
        setAcceptOfferUploading(true);
        setAcceptOfferError('');
        try {
          const token = localStorage.getItem('authToken');
          const formData = new FormData();
          formData.append('document', acceptOfferFile);
          formData.append('email', profile.email);

          const res = await fetch(`/api/student/applications/accept-offer/${acceptingApp._id}`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: formData
          });
          const data = await res.json();
          if (!data.success) {
            setAcceptOfferError(data.message || "Could not upload document.");
            setAcceptOfferUploading(false);
            return;
          }
          setShowAcceptOfferModal(false);
          setAcceptingApp(null);
          setAcceptOfferFile(null);
          setAcceptOfferUploading(false);
          fetchApplications(profile.email);
        } catch (err) {
          setAcceptOfferError("Upload failed. Try again.");
          setAcceptOfferUploading(false);
        }
      }}
    >
      Yes, Submit
    </Button>
  </Modal.Footer>
</Modal>

     
      {/* --- Message Admin Modal --- */}
     <MessageAdminModal
  show={showAdminMsgModal}
  onHide={() => setShowAdminMsgModal(false)}
  adminMsgText={adminMsgText}
  setAdminMsgText={setAdminMsgText}
  handleSendAdminMsg={handleSendAdminMsg}
  adminMsgSendError={adminMsgSendError}
  adminMsgSendSuccess={adminMsgSendSuccess}
/>


{/* --- Application Messages Modal --- */}
<ApplicationMessagesModal
  show={showAppMsgModal}
  onHide={() => setShowAppMsgModal(false)}
  activeAppMsg={activeAppMsg}
  appMsgThread={appMsgThread}
  appMsgLoading={appMsgLoading}
  appMsgText={appMsgText}
  setAppMsgText={setAppMsgText}
  appMsgError={appMsgError}
  handleSendAppMsg={handleSendAppMsg}
/>



    {/* --- Admin Thread Modal --- */}
<AdminThreadModal
  show={showAdminThread}
  onHide={() => setShowAdminThread(false)}
  adminMessages={adminMessages}
/>




      {/* === Application Form Modal === */}
<Modal show={showAppFormModal} onHide={() => setShowAppFormModal(false)} size="xl">
  <Modal.Header closeButton>
    <Modal.Title> Admissions Form</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* For now, a placeholder. We'll add full fields in the next step */}
    <Form>
  {/* Photo upload code (as before) */}
  <Form.Group className="mb-3">
    <Form.Label><b>Attach Photograph</b></Form.Label>
    <div>
      {applicationForm.photo ? (
  <img
    src={
      applicationForm.photo.startsWith("http")
        ? applicationForm.photo
        : `${API_BASE}${applicationForm.photo}`
    }
    alt="Uploaded"
    style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 12, marginBottom: 12, border: '1px solid #ddd' }}
  />
) : (
  <div style={{
    width: 120, height: 120, background: '#f2f2f2', border: '1px dashed #aaa',
    borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: '#bbb', marginBottom: 12
  }}>
    No Photo
  </div>
)}

    </div>
   <Form.Control
  type="file"
  accept="image/*"
  onChange={async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 3 * 1024 * 1024) {
      alert("Photo too large! Max 3 MB.");
      e.target.value = "";
      return;
    }

    // Prepare upload as FormData
    const formData = new FormData();
    formData.append('email', profile.email); // student email for filename
    formData.append('document', file);
    formData.append('documentType', 'photo');

    const token = localStorage.getItem('authToken');
    try {
      const res = await fetch('/api/student/upload-document', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const data = await res.json();
      if (data.success && data.document && data.document.url) {
        setApplicationForm(form => ({
          ...form,
          photo: data.document.url // Store uploaded URL, not base64
        }));

        const token = localStorage.getItem('authToken');
fetch('/api/student/admission-form', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  },
  body: JSON.stringify({
    email: profile.email,
    admissionForm: {
      ...applicationForm,
      photo: data.document.url
    }
  })
});

          // Also add to student documents if not already there
        setProfile(prev => {
          const already = (prev.documents || []).some(
            d => d.url === data.document.url || d.name === "photo"
          );
          if (already) return prev;
          return {
            ...prev,
            documents: [...(prev.documents || []), data.document]
          };
        });
        alert("Photo uploaded successfully!");
      } else {
        alert("Photo upload failed.");
      }
    } catch (err) {
      alert("Photo upload failed.");
    }
    e.target.value = "";
  }}
/>
<Form.Text>Click to upload your photo (JPG, PNG, etc.)</Form.Text>

  </Form.Group>

  {/* Program Applied For */}
  <Form.Group className="mb-2">
  <Form.Label>Program Applied For (For Official Use)</Form.Label>
  <Form.Control
    type="text"
    value={applicationForm.program}
    disabled // <--- THIS disables the field!
    readOnly // <--- Optional, double-protection
  />
</Form.Group>


  {/* Alternative Program */}
  <Form.Group className="mb-2">
  <Form.Label>Alternative Program (For Official Use)</Form.Label>
  <Form.Control
    type="text"
    value={applicationForm.altProgram}
    disabled
    readOnly
  />
</Form.Group>


  {/* Roll No */}
  <Form.Group className="mb-2">
  <Form.Label>Roll No (For Official Use)</Form.Label>
  <Form.Control
    type="text"
    value={applicationForm.rollNo}
    disabled
    readOnly
  />
</Form.Group>


  {/* Student Name */}
  <Form.Group className="mb-2">
    <Form.Label>Student Name</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.name}
      onChange={e => setApplicationForm(form => ({ ...form, name: e.target.value }))}
    />
  </Form.Group>

  {/* Father Name */}
  <Form.Group className="mb-2">
    <Form.Label>Father's Name</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.fatherName}
      onChange={e => setApplicationForm(form => ({ ...form, fatherName: e.target.value }))}
    />
  </Form.Group>

  {/* CNIC */}
  <Form.Group className="mb-2">
    <Form.Label>Student CNIC</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.cnic}
      onChange={e => setApplicationForm(form => ({ ...form, cnic: e.target.value }))}
    />
  </Form.Group>

  {/* Date of Birth */}
  <Form.Group className="mb-2">
    <Form.Label>Date of Birth</Form.Label>
    <Form.Control
      type="date"
      value={applicationForm.dob}
      onChange={e => setApplicationForm(form => ({ ...form, dob: e.target.value }))}
    />
  </Form.Group>

  {/* Gender */}
  <Form.Group className="mb-2">
    <Form.Label>Gender</Form.Label><br />
    <Form.Check
      inline
      label="Male"
      name="gender"
      type="radio"
      checked={applicationForm.gender === "Male"}
      onChange={() => setApplicationForm(form => ({ ...form, gender: "Male" }))}
    />
    <Form.Check
      inline
      label="Female"
      name="gender"
      type="radio"
      checked={applicationForm.gender === "Female"}
      onChange={() => setApplicationForm(form => ({ ...form, gender: "Female" }))}
    />
    <Form.Check
      inline
      label="Other"
      name="gender"
      type="radio"
      checked={applicationForm.gender === "Other"}
      onChange={() => setApplicationForm(form => ({ ...form, gender: "Other" }))}
    />
  </Form.Group>

  {/* Present Address */}
  <Form.Group className="mb-2">
    <Form.Label>Present Address</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.presentAddress}
      onChange={e => setApplicationForm(form => ({ ...form, presentAddress: e.target.value }))}
    />
  </Form.Group>

  {/* Permanent Address */}
  <Form.Group className="mb-2">
    <Form.Label>Permanent Address</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.permanentAddress}
      onChange={e => setApplicationForm(form => ({ ...form, permanentAddress: e.target.value }))}
    />
  </Form.Group>

  {/* Domicile */}
  <Form.Group className="mb-2">
    <Form.Label>Domicile</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.domicile}
      onChange={e => setApplicationForm(form => ({ ...form, domicile: e.target.value }))}
    />
  </Form.Group>

  {/* Locality */}
  <Form.Group className="mb-2">
    <Form.Label>Locality</Form.Label><br />
    <Form.Check
      inline
      label="Urban"
      name="locality"
      type="radio"
      checked={applicationForm.locality === "Urban"}
      onChange={() => setApplicationForm(form => ({ ...form, locality: "Urban" }))}
    />
    <Form.Check
      inline
      label="Rural"
      name="locality"
      type="radio"
      checked={applicationForm.locality === "Rural"}
      onChange={() => setApplicationForm(form => ({ ...form, locality: "Rural" }))}
    />
  </Form.Group>

  {/* Nationality */}
  <Form.Group className="mb-2">
    <Form.Label>Nationality</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.nationality}
      onChange={e => setApplicationForm(form => ({ ...form, nationality: e.target.value }))}
    />
  </Form.Group>

  {/* Marital Status */}
  <Form.Group className="mb-2">
    <Form.Label>Marital Status</Form.Label><br />
    <Form.Check
      inline
      label="Single"
      name="maritalStatus"
      type="radio"
      checked={applicationForm.maritalStatus === "Single"}
      onChange={() => setApplicationForm(form => ({ ...form, maritalStatus: "Single" }))}
    />
    <Form.Check
      inline
      label="Married"
      name="maritalStatus"
      type="radio"
      checked={applicationForm.maritalStatus === "Married"}
      onChange={() => setApplicationForm(form => ({ ...form, maritalStatus: "Married" }))}
    />
  </Form.Group>

  {/* Identification Mark */}
  <Form.Group className="mb-2">
    <Form.Label>Identification Mark</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.identificationMark}
      onChange={e => setApplicationForm(form => ({ ...form, identificationMark: e.target.value }))}
    />
  </Form.Group>

  {/* Religion */}
  <Form.Group className="mb-2">
    <Form.Label>Religion</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.religion}
      onChange={e => setApplicationForm(form => ({ ...form, religion: e.target.value }))}
    />
  </Form.Group>

  {/* Blood Group */}
  <Form.Group className="mb-2">
    <Form.Label>Blood Group</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.bloodGroup}
      onChange={e => setApplicationForm(form => ({ ...form, bloodGroup: e.target.value }))}
    />
  </Form.Group>

  {/* Email ID */}
  <Form.Group className="mb-2">
    <Form.Label>Email ID</Form.Label>
    <Form.Control
      type="email"
      value={applicationForm.email}
      onChange={e => setApplicationForm(form => ({ ...form, email: e.target.value }))}
    />
  </Form.Group>

  {/* Guardian Cell No */}
  <Form.Group className="mb-2">
    <Form.Label>Guardian Cell No</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.guardianCell}
      onChange={e => setApplicationForm(form => ({ ...form, guardianCell: e.target.value }))}
    />
  </Form.Group>

  {/* Cell No */}
  <Form.Group className="mb-2">
    <Form.Label>Cell No</Form.Label>
    <Form.Control
      type="text"
      value={applicationForm.cell}
      onChange={e => setApplicationForm(form => ({ ...form, cell: e.target.value }))}
    />
  </Form.Group>
  {/* Academic Qualifications Section */}
<div style={{display: 'flex', alignItems: 'center', marginTop: 24, marginBottom: 12}}>
  <h5 style={{margin: 0, flex: 1}}>Academic Qualifications</h5>
  <Button
    variant="outline-primary"
    size="sm"
    style={{marginLeft: 10}}
    onClick={() =>
      setApplicationForm(form => ({
        ...form,
        academicRecords: [
          ...(Array.isArray(form.academicRecords) ? form.academicRecords : []),
          {
            qualification: '',
            passingYear: '',
            rollNo: '',
            totalMarks: '',
            obtainedMarks: '',
            percentage: '',
            board: '',
            registrationNo: '',
            examination: ''
          }
        ]
      }))
    }
  >
    + Add Row
  </Button>
  <Button
    variant="outline-danger"
    size="sm"
    style={{marginLeft: 10}}
    onClick={() =>
      setApplicationForm(form => ({
        ...form,
        academicRecords: (Array.isArray(form.academicRecords) && form.academicRecords.length > 1)
          ? form.academicRecords.slice(0, -1)
          : (Array.isArray(form.academicRecords) ? form.academicRecords : [])
      }))
    }
    disabled={(Array.isArray(applicationForm.academicRecords) ? applicationForm.academicRecords.length : 0) === 1}
  >
    - Delete Row
  </Button>
</div>
<div style={{overflowX: 'auto'}}>
  <Table bordered hover responsive>
    <thead>
      <tr>
        <th>Qualification</th>
        <th>Passing Year</th>
        <th>Roll No</th>
        <th>Total Marks</th>
        <th>Obtained Marks</th>
        <th>%</th>
        <th>Board/University</th>
        <th>Reg No</th>
        <th>Examination</th>
      </tr>
    </thead>
    <tbody>
      {(Array.isArray(applicationForm.academicRecords) ? applicationForm.academicRecords : []).map((row, idx) => (
        <tr key={idx}>
          {/* ...your <td> cells as before, no change needed inside ... */}
          <td>
            <Form.Select
              value={row.qualification}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].qualification = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            >
              <option value="">Select</option>
              <option value="Matriculation">Matriculation</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Bachelors">Bachelors</option>
              <option value="Others">Others</option>
            </Form.Select>
          </td>
          {/* ...repeat for all other fields, as already in your code... */}
          {/* (no changes needed inside each td!) */}
          <td>
            <Form.Control
              type="text"
              value={row.passingYear}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].passingYear = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              value={row.rollNo}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].rollNo = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              value={row.totalMarks}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].totalMarks = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              value={row.obtainedMarks}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].obtainedMarks = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              value={row.percentage}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].percentage = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              value={row.board}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].board = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              value={row.registrationNo}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].registrationNo = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            />
          </td>
          <td>
            <Form.Control
              type="text"
              value={row.examination}
              onChange={e => {
                const newRows = [...applicationForm.academicRecords];
                newRows[idx].examination = e.target.value;
                setApplicationForm(form => ({ ...form, academicRecords: newRows }));
              }}
            />
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
</div>
{/* Document Checklist */}
<h5 className="mt-4">Document Checklist</h5>
<h5 className="mt-4">Document Checklist</h5>
<Form.Group>
  {[
    { key: 'matriculation', label: 'Matriculation Certificate' },
    { key: 'intermediate', label: 'Intermediate Certificate' },
    { key: 'graduation', label: 'Graduation Certificate' },
    { key: 'photographs', label: 'Photographs' },
    { key: 'cnicStudent', label: 'CNIC (Student)' },
    { key: 'cnicStudentBack', label: 'CNIC (Student) (Back)' },
    { key: 'cnicFather', label: 'CNIC (Father/Guardian)' },
    { key: 'cnicFatherBack', label: 'CNIC (Father/Guardian) (Back)' },
    { key: 'domicile', label: 'Domicile' }
  ].map(({ key, label }) => {
    const uploadedDoc = getChecklistDoc(key);
    return (
      <div key={key} style={{ display: "flex", alignItems: "center", marginBottom: 8, gap: 12 }}>
        <Form.Check
          type="checkbox"
          label={label}
          checked={!!(applicationForm.documentChecklist && applicationForm.documentChecklist[key])}
          onChange={e =>
            setApplicationForm(form => ({
              ...form,
              documentChecklist: { ...form.documentChecklist, [key]: e.target.checked }
            }))
          }
        />
        {/* Show upload if checked */}
        {(applicationForm.documentChecklist && applicationForm.documentChecklist[key]) && (
          <>
            {!uploadedDoc ? (
              <Form.Control
                type="file"
                size="sm"
                style={{ width: 220 }}
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif"
                onChange={e => handleChecklistDocUpload(e, key, label.replace(/ /g, '_'))}
              />
            ) : (
              <>
                <a
  href={uploadedDoc.url || uploadedDoc.data}
  download={uploadedDoc.name}
  target="_blank"
  rel="noopener noreferrer"
  style={{ marginRight: 8 }}
>
  {uploadedDoc.name}
</a>

                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => removeChecklistDoc(key)}
                >
                  Remove
                </Button>
              </>
            )}
          </>
        )}
      </div>
    );
  })}
</Form.Group>

<p className="text-primary mt-2" style={{ fontStyle: 'italic', fontWeight: 500 }}>
  Please upload other documents in your profile.
</p>


{/* Declaration */}
<h5 className="mt-4">Declaration</h5>
<p>
  I hereby Declare that the information and documents supplied with this application are true, correct and complete. Incorrect information or withholding any part of it would disqualify me. I agree that Institute or University has right to amend the program courses or enhance the course fee etc., if necessary, I will pay all my dues in-time. The fee paid by me will be non-refundable and non-transferable. I undertake to abide by the rules and regulations of the institute or university wholeheartedly
</p>
<Form.Check
  type="checkbox"
  label="I agree with the declaration above"
  checked={!!applicationForm.declarationAgreed}
  onChange={e =>
    setApplicationForm(form => ({ ...form, declarationAgreed: e.target.checked }))
  }
/>

  </Form>
  </Modal.Body>
  <Modal.Footer>
    {docUploadError && (
  <Alert variant="danger" className="w-100 text-center">
    {docUploadError}
  </Alert>
)}

    <Button variant="secondary" onClick={() => setShowAppFormModal(false)}>
  Close
</Button>
<Button
  variant="success"
  onClick={() => {
    // Document checklist array (keep in sync with your list!)
    const checklist = [
      { key: 'matriculation', label: 'Matriculation Certificate' },
      { key: 'intermediate', label: 'Intermediate Certificate' },
      { key: 'graduation', label: 'Graduation Certificate' },
      { key: 'photographs', label: 'Photographs' },
      { key: 'cnicStudent', label: 'CNIC (Student)' },
      { key: 'cnicStudentBack', label: 'CNIC (Student) (Back)' },
      { key: 'cnicFather', label: 'CNIC (Father/Guardian)' },
      { key: 'cnicFatherBack', label: 'CNIC (Father/Guardian) (Back)' },
      { key: 'domicile', label: 'Domicile' }
    ];

    const docChecklist = applicationForm.documentChecklist || {};
    const missing = checklist.filter(item =>
      docChecklist[item.key] && !getChecklistDoc(item.key)
    );

    if (missing.length > 0) {
      setDocUploadError(
        'Please upload the following document(s): ' +
        missing.map(m => m.label).join(', ')
      );
      return;
    }

    setDocUploadError('');
    const appFormToSave = {
      ...applicationForm,
      documentChecklist: docChecklist // only save checklist, always defined
    };

    const token = localStorage.getItem('authToken');
fetch('/api/student/admission-form', {
  method: 'POST',
  headers: { 
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  },
  body: JSON.stringify({ email: student.email, admissionForm: appFormToSave })
})
  .then(res => res.json())
  .then(data => {
    if (data.admissionForm) {
      setShowAppFormModal(false);
      setTimeout(() => {
        alert('Application Form saved successfully!');
      }, 200);
      setApplicationFormSaved(true);   // <--- NEW: Set flag true
    } else {
      alert('Could not save form. Try again.');
      setApplicationFormSaved(false);  // <--- NEW: Set flag false if error
    }
  })
  .catch(() => {
    alert('Could not connect to server. Try again.');
    setApplicationFormSaved(false);    // <--- NEW: Set flag false if error
  });


  }}
  disabled={!applicationForm.declarationAgreed}
>
  Save
</Button>



  </Modal.Footer>
</Modal>
<Modal
  show={showPaymentModal}
  onHide={() => setShowPaymentModal(false)}
  size="sm"
  centered
  contentClassName="p-2"
>
  <Modal.Header closeButton>
    <Modal.Title style={{ fontSize: 18, width: "100%", textAlign: "center" }}>
      Payment Instructions
    </Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ fontSize: 16, textAlign: "center" }}>
  <div style={{ textAlign: "left", fontSize: 15, lineHeight: 1.6 }}>
    <b>Jazz Cash</b><br />
    Account ………………………………………<br />
    Account Name ……………………………<br /><br />

    <b>EasyPaisa</b><br />
    Account ……………………………………………………<br />
    Account Name …………………………………………<br /><br />

    <b>Mezan Bank</b><br />
    Account ………………………………………………….<br />
    Account Name …………………………………………..
  </div>

  <div style={{ marginTop: 18, textAlign: "left" }}>
    <b>Please upload your payment confirmation receipt here:</b>
   <Form.Control
  type="file"
  accept="image/*,application/pdf"
  style={{ marginTop: 8, maxWidth: 320 }}
  size="sm"
  onChange={async e => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 1024 * 1024) { // 1 MB limit for receipts
        alert('File is too large! Please upload files smaller than 1 MB.');
        e.target.value = "";
        return;
      }
      const formData = new FormData();
      formData.append('email', profile.email);
      formData.append('document', file);
      formData.append('documentType', 'paymentReceipt');
      formData.append('typeTag', 'paymentReceipt');
      const token = localStorage.getItem('authToken');
      try {
        const res = await fetch('/api/student/upload-document', {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}` },
          body: formData
        });
        const data = await res.json();
        if (data.success && data.document) {
          setPaymentReceipt({
            name: data.document.name,
            url: data.document.url,
            type: data.document.type,
          });
          setProfile(prev => ({
            ...prev,
            paymentReceipt: {
              name: data.document.name,
              url: data.document.url,
              type: data.document.type,
            }
          }));
        } else {
          alert('Could not save receipt. Try again.');
        }
        e.target.value = "";
      } catch {
        alert('Could not connect to server. Try again.');
        e.target.value = "";
      }
    }
  }}
/>

    {paymentReceipt && (
      <div style={{ marginTop: 8, color: "#2e7d32", fontWeight: 500 }}>
        Uploaded: {paymentReceipt.name}
      </div>
    )}
  </div>
</Modal.Body>

  <Modal.Footer className="justify-content-center">
  <Button
    variant="secondary"
    size="sm"
    style={{ minWidth: 80 }}
    onClick={() => {
      setShowPaymentModal(false);
      setPaymentReceipt(null);
    }}
  >
    Close
  </Button>
</Modal.Footer>

</Modal>

    </div>
  );
}

export default StudentDashboard;
